module.exports = __webpack_public_path__ + "static/media/Florida Association of Community Health Centers Logo.a466f1a7.png";